"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Events = exports.UPCOMING_AND_PAST_STATUSES = exports.UPCOMING_STATUSES = void 0;
var tslib_1 = require("tslib");
var ImageSDK_1 = require("../ImageSDK/ImageSDK");
var types_1 = require("@wix/ambassador-events-v1-event/types");
var helpers_1 = require("./helpers");
exports.UPCOMING_STATUSES = [
    types_1.EventStatus.STARTED,
    types_1.EventStatus.SCHEDULED,
    types_1.EventStatus.DRAFT,
];
exports.UPCOMING_AND_PAST_STATUSES = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(exports.UPCOMING_STATUSES)), [
    types_1.EventStatus.ENDED,
]);
var Events = /** @class */ (function () {
    function Events(events, groupEventIds, restrictedEventIds) {
        var _this = this;
        this.groupRestrictedEventIds = new Set();
        this.toGroupEvent = function (event) {
            var id = event.id, title = event.title, location = event.location, scheduling = event.scheduling, status = event.status, dashboard = event.dashboard, registration = event.registration, mainImage = event.mainImage, group = event.group;
            var summary;
            var type = registration === null || registration === void 0 ? void 0 : registration.type;
            if (registration && registration.type) {
                summary =
                    registration.type === types_1.EventType.RSVP
                        ? dashboard.rsvpSummary
                        : dashboard.ticketingSummary;
            }
            return tslib_1.__assign({ id: id,
                group: group, name: title, isGroupEvent: _this.isGroupEvent(id), isRestrictedEvent: _this.isRestrictedEvent(id), scheduleTbdMessage: helpers_1.getScheduleTbdMessage(event), startDate: new Date(scheduling.config.startDate), endDate: new Date(scheduling.config.endDate), address: location.address || location.name, status: status,
                type: type,
                summary: summary,
                mainImage: mainImage }, event);
        };
        this.setGroupEvents(events, groupEventIds, restrictedEventIds);
    }
    Events.prototype.setGroupEvents = function (events, groupEventIds, restrictedEventIds) {
        if (restrictedEventIds === void 0) { restrictedEventIds = []; }
        this.groupEventIds = new Set(groupEventIds);
        this.groupRestrictedEventIds = new Set(restrictedEventIds);
        this.groupEvents = events.map(this.toGroupEvent);
        this.setEventsMap();
    };
    Events.prototype.setEventsMap = function () {
        this.eventsMap = this.groupEvents.reduce(function (map, ev) {
            map.set(ev.id, ev);
            return map;
        }, new Map());
    };
    Events.prototype.getEvents = function () {
        return this.groupEvents;
    };
    Events.prototype.setRestrictedEventIds = function (ids) {
        this.groupRestrictedEventIds = new Set(ids);
    };
    Events.prototype.isRestrictedEvent = function (id) {
        return this.groupRestrictedEventIds.has(id);
    };
    Events.prototype.addToGroupEvents = function (ids) {
        var e_1, _a;
        try {
            for (var ids_1 = tslib_1.__values(ids), ids_1_1 = ids_1.next(); !ids_1_1.done; ids_1_1 = ids_1.next()) {
                var id = ids_1_1.value;
                this.groupEventIds.add(id);
                var ev = this.eventsMap.get(id);
                ev.isGroupEvent = true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ids_1_1 && !ids_1_1.done && (_a = ids_1.return)) _a.call(ids_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Events.prototype.removeFromGroupEvents = function (ids) {
        var e_2, _a;
        try {
            for (var ids_2 = tslib_1.__values(ids), ids_2_1 = ids_2.next(); !ids_2_1.done; ids_2_1 = ids_2.next()) {
                var id = ids_2_1.value;
                this.groupEventIds.delete(id);
                var ev = this.eventsMap.get(id);
                ev.isGroupEvent = false;
                ev.group = null;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (ids_2_1 && !ids_2_1.done && (_a = ids_2.return)) _a.call(ids_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Events.prototype.isGroupEvent = function (id) {
        return this.groupEventIds.has(id);
    };
    Events.prototype.getUpcomingEvents = function () {
        return this.groupEvents.filter(Events.isUpcoming);
    };
    Events.prototype.getPastEvents = function () {
        return this.groupEvents.filter(function (ev) { return ev.status === types_1.EventStatus.ENDED; });
    };
    Events.prototype.getThumb = function (mainImage, size) {
        var id = mainImage.id, width = mainImage.width, height = mainImage.height;
        var sdk = new ImageSDK_1.ImageSDK({
            relativeUrl: id,
            sourceWidth: width,
            sourceHeight: height,
            targetWidth: size.width,
            targetHeight: size.height,
            url: null,
        });
        return sdk.getScaledUrl();
    };
    Events.prototype.getEventThumb = function (groupEventId, size) {
        var event = this.eventsMap.get(groupEventId);
        return event.mainImage && this.getThumb(event.mainImage, size);
    };
    Events.prototype.getStartDate = function (groupEventId, locale) {
        var event = this.eventsMap.get(groupEventId);
        return event.startDate && this.getLocaleDate(event.startDate, locale);
    };
    Events.prototype.getEndDate = function (groupEventId, locale) {
        var event = this.eventsMap.get(groupEventId);
        return event.endDate && this.getLocaleDate(event.endDate, locale);
    };
    Events.prototype.getLocaleDate = function (date, locale) {
        var options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        };
        return date.toLocaleString(locale, options);
    };
    Events.fromGroupEvents = function (groupEvents) {
        var events = new Events([], []);
        events.groupEvents = groupEvents;
        events.setEventsMap();
        return events;
    };
    Events.isUpcoming = function (event) {
        return exports.UPCOMING_STATUSES.includes(event.status);
    };
    return Events;
}());
exports.Events = Events;
//# sourceMappingURL=Events.js.map